import { SelectedTip } from '@/resources/types'

export const shouldShowSelectedTip = (
  selectedTip?: SelectedTip | null
): boolean => (selectedTip?.selectedTipValue ?? 0) > 0
